
<template>
  <div
    v-title
    class="main-content noBreadcrumb"
    data-title="试剂耗材采购库存管理系统"
    id="home"
  >
    <div class="product-conatiner">
      <h2>{{ info.slogan }}</h2>

      <div class="max-search">
        <div class="search-con">


          <div class="homeTab">
            <el-tabs type="card" v-model="businessTypeTab" @tab-click="handleTabClick">
              <el-tab-pane label="试剂" name="first"></el-tab-pane>
              <el-tab-pane label="耗材" name="second"></el-tab-pane>
            </el-tabs>
          </div>
          <div>
            <img src="../../assets/images/searchIcon.png" alt="" />
            <div v-show="this.businessTypeTab == 'first'">
              <input
                  type="text" style="width: 700px;line-height: 80px;height: 50px;"
                  v-model.trim="searchValue"
                  placeholder="请输入CAS号/分子式/中文名/英文名查询"
                  @keyup.enter="searchClick()"
              />
              <el-button slot="suffix"   @click="structureFun()" style="left:-30px;width: 68px;height: 30px;
                font-size: 10px;
                margin: auto;
                text-align: center;
                line-height: 6px;
                margin-top: 5px;margin-left: -80px;background: #478aff;color: #ffffff;
            }" >结构式</el-button>
            </div>
            <div v-show="this.businessTypeTab == 'second'">
              <input
                  type="text" style="width: 700px;line-height: 80px;height: 50px;"
                  v-model.trim="searchValue"
                  placeholder="请输入耗材名称/货号"
                  @keyup.enter="searchMaterialClick()"
              />
            </div>
          </div>

          <!--热门搜索-->
<!--          <div v-show="this.businessTypeTab == 'second'">-->
<!--            <div style="padding-top: 8px">-->
<!--              <el-link type="info" :underline="false">热搜: </el-link>-->
<!--              <span style="padding-left: 10px;" v-for="(item, index) in hotSearchData" :key="index">-->
<!--                <el-button size="mini" style="background-color: #F0F0F0;border-color: #F0F0F0;color: black" type="info" @click="payHotGoods(item.hotSearch)" round>{{item.hotSearch}}</el-button>-->
<!--              </span>-->
<!--            </div>-->
<!--          </div>-->
          <div v-show="this.businessTypeTab == 'second'">
            <div style="padding-top: 8px;">
              <el-row :gutter="1">
                <el-col :span="2" style="width: 35px;">
                  <el-link type="info" :underline="false">热搜:</el-link>
                </el-col>
                <el-col :span="25" style="width: 655px;">
                  <div style="padding-left: 10px;padding-bottom: 5px;display: inline-block; align-content: flex-start;" v-for="(item, index) in hotSearchData" :key="index">
                    <el-button size="mini" style="background-color: #F0F0F0;border-color: #F0F0F0;color: black;" type="info"
                           @click="payHotGoods(item.hotSearch)" round>{{ item.hotSearch }}</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <div v-show="typeValue == 'smiles'" ref="structDiv">
            <el-tabs type="card" v-model="activeTab" @tab-click="changeTab">
              <el-tab-pane label="jsme" name="JSME">
                <div
                    class="jsme_container"
                    width="620"
                    height="430"
                    id="jsme_container"
                    ref="jsme_container"
                ></div>
              </el-tab-pane>
              <el-tab-pane label="ketcher" name="Ketcher">
                <iframe class="frame" id="idKetcher" src="./standalone/index.html" width="700" height="430" />
              </el-tab-pane>

            </el-tabs>
          </div>
          <div v-show="typeValue == 'name'">
            <img src="../../assets/images/searchIcon.png" alt="" />
            <input
              type="text"
              v-model.trim="searchName"
              placeholder="请输入分子式/中文名/英文名"
              @keyup.enter="searchClick()"
            />
          </div>
        </div>
        <div v-show="this.businessTypeTab == 'first'">
          <el-button class="search-btn" @click="searchClick()" v-loading.fullscreen.lock="fullscreenLoading">
            智能搜索
          </el-button>
        </div>
        <div v-show="this.businessTypeTab == 'second'">
          <el-button class="search-btn" @click="searchMaterialClick()" v-loading.fullscreen.lock="fullscreenLoading">
            智能搜索
          </el-button>
        </div>
      </div>
    </div>
<!--    <div class="tips" v-if="info.copyright">-->
<!--      <span-->
<!--        >沪ICP备2021028033号-1 {{ info.copyright ? "|" : "" }}-->
<!--        {{ info.copyright }}</span-->
<!--      >-->
<!--    </div>-->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hotSearchData: [
          {"goodsName":"丁腈手套","goodsId":0},
          {"goodsName":"大龙移液枪","goodsId":1},
          {"goodsName":"移液器吸头/枪头","goodsId":2},
      ],
      businessTypeTab: "first",
      activeTab:'JSME',
      ketcher: null,
      ketcherSmiles: null,
      typeList: [
        {
          value: "all",
          label: "快速查询",
        },
        {
          value: "smiles",
          label: "结构式查询",
        },
      ],
      typeValue: "all",
      searchValue: "",
      videoSrc:
        "http://wxsnsdy.tc.qq.com/105/20210/snsdyvideodownload?filekey=30280201010421301f0201690402534804102ca905ce620b1241b726bc41dcff44e00204012882540400&bizid=1023&hy=SH&fileparam=302c020101042530230204136ffd93020457e3c4ff02024ef202031e8d7f02030f42400204045a320a0201000400", //获取视频播放资源
      bannerList: [],
      productList: [],
      newsList: [],
      videoStatus: true,
      smiles: "",
      firstflag: true,
      info: "",
      activedIndex: 0,
      searchName: "",
      fullscreenLoading: false,
    };
  },

  created() {
    // this.initKetcher()
  },
  mounted() {
    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      location.reload();
      this.getLoker();
    }
    this.getLoker();
//todo
    document.getElementById("home").addEventListener("click",(e)=>{
      if(e.target.innerText!="结构式" && this.$refs.jsme_container!=undefined && !this.$refs.structDiv.contains(e.target)){
         this.activedIndex = 0;
          this.typeValue = 'all';
      }
    })
  },
  methods: {
    handleTabClick(tab, event){
      const tabName = tab._props.name;
      if('second' == tabName){
        this.getHotSearch();
      }
    },

    payHotGoods(goodsName){
      this.$router.push({ name: "expendMaterial", params: { goodsName: goodsName } });

    },


    async getKetcherSmiles(){
      this.initKetcher();
      let ketcherSmiles = ""
      await this.ketcher
            .getSmiles()
            .then(res => {
              console.log("ketcher smiles = ",res)
              ketcherSmiles = res
            })
            .catch(e => {
              console.log(e)
            })
      return ketcherSmiles;
    },
    changeTab(){

    },
    initKetcher() {
      let ketcherFrame = document.getElementById('idKetcher')
      let ketcher = null
      if ('contentDocument' in ketcherFrame) {
        ketcher = ketcherFrame.contentWindow.ketcher
      } else {
        ketcher = document.frames['idKetcher'].window.ketcher
      }
      this.ketcher = ketcher
    },
    // 添加搜索记录到库中
    addSearchLog(content){
      try{
        this.$apiFetch
            .post(`/searchLog/add`,{searchContent:content,logType: 1})
            .then(function (res) {
              if(res.data){
                console.log("搜索记录添加成功.",res.data)
              }
            });
      }catch (e) {
        console.log(e)
      }
    },
    getLoker() {
      this.$apiFetch
        .get("/lockerCopywriting/list")
        .then((data) => {
          this.info = data.data[0];
          localStorage.setItem("platformInfo", JSON.stringify(this.info));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getHotSearch() {
      this.$apiFetch
          .get("/lockerGoods/material/hotSearch").then((res) => {
            this.hotSearchData = res.data;
          })
          .catch((error) => {
          });
    },
    typechange(e) {
      console.log("选择搜索方式", e);
      // if(e != 'all'&& this.firstflag){
      //   this.firstflag = false
      //   console.log('第一次渲染')
      //   window.jsmeOnLoad()
      // }
    },
    structureFun(){
      if(this.activedIndex==0){
        this.activedIndex = 1;
        this.typeValue = 'smiles';
      }
      else{
        this.activedIndex = 0;
        this.typeValue = 'all';
      }
    },
    //查询

    async searchClick() {
      let alias = this.searchValue;
      let self = this;
      if (this.typeValue == "all") {
        if(!alias){
          return ;
        }
        if(alias.trim()==""){
          return ;
        }
        this.addSearchLog(this.searchValue);
        this.$router.push({ path: `searchPage?alias=${alias}&searchType=1` });
      } else if (this.typeValue == "smiles") {
        console.log(this.activeTab)
        if(this.activeTab == 'JSME'){
          this.smiles = window.JSApplet.smiles();
        }else if(this.activeTab == 'Ketcher'){
        //todo
        //   this.initKetcher();
          this.smiles = await this.getKetcherSmiles();
        }
        if(!this.smiles){
          return ;
        }
        console.log('smiles号',this.smiles)
        await this.addSearchLog(this.smiles);
        let encodeSmiles = encodeURIComponent(this.smiles);
        this.$router.push({ path: `searchPage?alias=${encodeSmiles}&searchType=3` });
      } else if (this.typeValue == "name") {
        let name = this.searchName;
        this.addSearchLog(this.searchValue);
        window.location.href = `/searchPage?name=${name}&searchType=2`;
      }
    },



    searchMaterialClick(){
      let alias = this.searchValue;
      if(!alias){
        return
      }
      this.payHotGoods(alias);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .homeTab {
  width: 200px;
  .el-tabs--border-card>.el-tabs__content {
    padding: 0;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__item {
    padding: 0 30px;
    font-size: 16px;
  }
  .el-tabs__item.is-active {
    color: #fff;
    background-color: #478aff;
  }
  .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border-radius: 13px 13px 0 0;
    border: 1px solid #E4E7ED;
  }
  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: transparent;
  }
  .el-tabs--card>.el-tabs__header .el-tabs__item {
    border-radius: 13px 13px 0 0;
  }
  .el-tabs__item is-top is-active {
    padding-left: 30px;
  }
  .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
    padding-left: 30px;
  }
  .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
    padding-right: 30px;
  }
}


.main-content {
  position: relative;
  background-color: #ffffff;
  .tips {
    text-align: center;
    position: absolute;
    bottom: 40px;
    width: 100%;
    z-index: 0;
    span {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
  }
}
.product-conatiner {
  // padding-bottom: 80px;
  h2 {
    font-size: 52px;
    font-weight: 500;
    color: #478aff;
    text-align: center;
    padding-top: 140px;
  }
  .max-search {
    display: flex;
    justify-content: center;
    margin-top: 25px;
    .search-type {
      width: 164px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      border-radius: 4px;
      color: #333333;
      border: 1px solid #cccccc;
      margin-right: 20px;
      /deep/ .el-input__inner {
        border: none;
        font-weight: 600;
      }
    }
    .search-con {
      position: relative;
      img {
        width: 20px;
        display: block;
        position: absolute;
        top: 56px;
        left: 24px;
      }
    }
    input {
      width: 700px;
      height: 54px;
      font-size: 16px;
      border-radius: 4px;
      border: 1px solid #cccccc;
      padding-left: 64px;
    }
    .search-btn {
      width: 151px;
      margin-left: 32px;
      margin-top: 37px;
      height: 54px;
      background: #478aff;
      border-radius: 4px;
      color: #ffffff;
      font-size: 22px;
    }
  }
}

.selectLine {
  margin: 0 auto;
  margin-top: 29px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e8e8e8;
  width: 884px;
  display: flex;

  .selectBox {
    background: rgba(51, 51, 51, 0.04);
    border-radius: 4px;
    text-align: center;
    height: 54px;
    line-height: 54px;
    padding: 0 25px;
    margin-right: 20px;

    &.active {
      background: #478aff;
      color: #fff;
    }
  }
}

/deep/.jsa-resetDiv {
  z-index: 99;
}
</style>

<!--#409eff-->
<!--#fff-->